(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cards"] && !Shopify.designMode) return;
  try {
    
  class CardsCursorPill extends HTMLElement {
    constructor() {
      super();
      this.sectionId = this.dataset.sectionId;
      this.pill = document.getElementById(`cursor-pill-${this.sectionId}`);
      this.cards = Array.from(this.querySelectorAll('.card'));
      this.isHovering = false;
      this.hideTimeout = null;
      this.isTouchDevice = 'ontouchstart' in window || navigator.maxTouchPoints > 0;
      this.eventHandlers = new Map(); // Store event handlers for proper cleanup
    }

    connectedCallback() {
      // Clean up any lingering state first
      this.cards.forEach((card) => {
        card.classList.remove('hide-cursor');
      });
      if (this.pill) {
        this.pill.classList.add('hidden', 'opacity-0');
        this.pill.style.left = '';
        this.pill.style.top = '';
      }

      // Don't show cursor pill on touch devices
      if (!this.pill || this.isTouchDevice) return;

      // Handle mouse events (desktop only)
      this.cards.forEach((card) => {
        const mouseEnterHandler = () => this.showPill(card);
        const mouseLeaveHandler = () => this.hidePill(card);
        const mouseMoveHandler = (e) => this.movePill(e);

        card.addEventListener('mouseenter', mouseEnterHandler);
        card.addEventListener('mouseleave', mouseLeaveHandler);
        card.addEventListener('mousemove', mouseMoveHandler);

        // Store handlers for cleanup
        if (!this.eventHandlers.has(card)) {
          this.eventHandlers.set(card, []);
        }
        this.eventHandlers
          .get(card)
          .push(
            { type: 'mouseenter', handler: mouseEnterHandler },
            { type: 'mouseleave', handler: mouseLeaveHandler },
            { type: 'mousemove', handler: mouseMoveHandler },
          );
      });
    }

    disconnectedCallback() {
      // Clean up all state when component is disconnected
      this.cleanup();
    }

    cleanup() {
      // Remove event listeners using stored handlers
      this.eventHandlers.forEach((handlers, card) => {
        handlers.forEach(({ type, handler }) => {
          card.removeEventListener(type, handler);
        });
      });
      this.eventHandlers.clear();

      // Clear any pending timeouts
      if (this.hideTimeout) {
        clearTimeout(this.hideTimeout);
        this.hideTimeout = null;
      }

      // Remove hide-cursor class from all cards
      this.cards.forEach((card) => {
        card.classList.remove('hide-cursor');
      });

      // Hide and reset cursor pill
      if (this.pill) {
        this.pill.classList.add('hidden', 'opacity-0');
        this.pill.style.left = '';
        this.pill.style.top = '';
      }

      this.isHovering = false;
    }

    showPill(card) {
      this.isHovering = true;

      if (this.hideTimeout) {
        clearTimeout(this.hideTimeout);
        this.hideTimeout = null;
      }

      this.pill.classList.remove('hidden', 'opacity-0');
      card.classList.add('hide-cursor');
    }

    hidePill(card) {
      this.isHovering = false;

      if (this.hideTimeout) {
        clearTimeout(this.hideTimeout);
      }

      this.hideTimeout = setTimeout(() => {
        if (!this.isHovering) {
          this.pill.classList.add('opacity-0');
          setTimeout(() => {
            if (!this.isHovering) {
              this.pill.classList.add('hidden');
            }
          }, 200);

          card.classList.remove('hide-cursor');
        }
      }, 50);
    }

    movePill(e) {
      if (!this.isHovering) return;

      requestAnimationFrame(() => {
        const rect = this.pill.getBoundingClientRect();
        this.pill.style.left = `${e.clientX - rect.width / 2}px`;
        this.pill.style.top = `${e.clientY - rect.height / 2}px`;
      });
    }
  }

  if (!customElements.get('cards-cursor-pill')) {
    customElements.define('cards-cursor-pill', CardsCursorPill);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection"]) return;
  try {
    
  class CardsCursorPill extends HTMLElement {
    constructor() {
      super();
      this.sectionId = this.dataset.sectionId;
      this.pill = document.getElementById(`cursor-pill-${this.sectionId}`);
      this.cards = Array.from(this.querySelectorAll('.card'));
      this.isHovering = false;
      this.hideTimeout = null;
      this.isTouchDevice = 'ontouchstart' in window || navigator.maxTouchPoints > 0;
      this.eventHandlers = new Map(); // Store event handlers for proper cleanup
    }

    connectedCallback() {
      // Clean up any lingering state first
      this.cards.forEach((card) => {
        card.classList.remove('hide-cursor');
      });
      if (this.pill) {
        this.pill.classList.add('hidden', 'opacity-0');
        this.pill.style.left = '';
        this.pill.style.top = '';
      }

      if (!this.pill) return;

      // Handle mouse events (desktop)
      this.cards.forEach((card) => {
        const mouseEnterHandler = () => this.showPill(card);
        const mouseLeaveHandler = () => this.hidePill(card);
        const mouseMoveHandler = (e) => this.movePill(e);

        card.addEventListener('mouseenter', mouseEnterHandler);
        card.addEventListener('mouseleave', mouseLeaveHandler);
        card.addEventListener('mousemove', mouseMoveHandler);

        // Store handlers for cleanup
        if (!this.eventHandlers.has(card)) {
          this.eventHandlers.set(card, []);
        }
        this.eventHandlers
          .get(card)
          .push(
            { type: 'mouseenter', handler: mouseEnterHandler },
            { type: 'mouseleave', handler: mouseLeaveHandler },
            { type: 'mousemove', handler: mouseMoveHandler },
          );
      });

      // Handle touch events (mobile/iOS) - show pill on touch, hide on touch end
      if (this.isTouchDevice) {
        this.cards.forEach((card) => {
          const touchStartHandler = (e) => {
            const touch = e.touches[0];
            this.showPill(card, touch.clientX, touch.clientY);
          };
          const touchEndHandler = () => this.hidePill(card);
          const touchCancelHandler = () => this.hidePill(card);
          const touchMoveHandler = (e) => {
            if (e.touches.length > 0) {
              const touch = e.touches[0];
              this.movePill(e, touch.clientX, touch.clientY);
            }
          };

          card.addEventListener('touchstart', touchStartHandler);
          card.addEventListener('touchend', touchEndHandler);
          card.addEventListener('touchcancel', touchCancelHandler);
          card.addEventListener('touchmove', touchMoveHandler);

          // Store handlers for cleanup
          if (!this.eventHandlers.has(card)) {
            this.eventHandlers.set(card, []);
          }
          this.eventHandlers
            .get(card)
            .push(
              { type: 'touchstart', handler: touchStartHandler },
              { type: 'touchend', handler: touchEndHandler },
              { type: 'touchcancel', handler: touchCancelHandler },
              { type: 'touchmove', handler: touchMoveHandler },
            );
        });
      }
    }

    disconnectedCallback() {
      // Clean up all state when component is disconnected
      this.cleanup();
    }

    cleanup() {
      // Remove event listeners using stored handlers
      this.eventHandlers.forEach((handlers, card) => {
        handlers.forEach(({ type, handler }) => {
          card.removeEventListener(type, handler);
        });
      });
      this.eventHandlers.clear();

      // Clear any pending timeouts
      if (this.hideTimeout) {
        clearTimeout(this.hideTimeout);
        this.hideTimeout = null;
      }

      // Remove hide-cursor class from all cards
      this.cards.forEach((card) => {
        card.classList.remove('hide-cursor');
      });

      // Hide and reset cursor pill
      if (this.pill) {
        this.pill.classList.add('hidden', 'opacity-0');
        this.pill.style.left = '';
        this.pill.style.top = '';
      }

      this.isHovering = false;
    }

    showPill(card, x = null, y = null) {
      this.isHovering = true;

      if (this.hideTimeout) {
        clearTimeout(this.hideTimeout);
        this.hideTimeout = null;
      }

      this.pill.classList.remove('hidden', 'opacity-0');

      // Position pill if coordinates provided (touch events)
      if (x !== null && y !== null) {
        const rect = this.pill.getBoundingClientRect();
        this.pill.style.left = `${x - rect.width / 2}px`;
        this.pill.style.top = `${y - rect.height / 2}px`;
      }

      // Hide system cursor on the card and all its children (desktop only)
      if (!this.isTouchDevice) {
        card.classList.add('hide-cursor');
      }
    }

    hidePill(card) {
      this.isHovering = false;

      if (this.hideTimeout) {
        clearTimeout(this.hideTimeout);
      }

      this.hideTimeout = setTimeout(() => {
        if (!this.isHovering) {
          this.pill.classList.add('opacity-0');
          setTimeout(() => {
            if (!this.isHovering) {
              this.pill.classList.add('hidden');
            }
          }, 200);

          // Restore system cursor (desktop only)
          if (!this.isTouchDevice) {
            card.classList.remove('hide-cursor');
          }
        }
      }, 50);
    }

    movePill(e, x = null, y = null) {
      if (!this.isHovering) return;

      requestAnimationFrame(() => {
        // Center the pill on the cursor/touch point
        const rect = this.pill.getBoundingClientRect();
        const clientX = x !== null ? x : e.clientX;
        const clientY = y !== null ? y : e.clientY;
        this.pill.style.left = `${clientX - rect.width / 2}px`;
        this.pill.style.top = `${clientY - rect.height / 2}px`;
      });
    }
  }

  if (!customElements.get('cards-cursor-pill')) {
    customElements.define('cards-cursor-pill', CardsCursorPill);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class SiteHeader extends HTMLElement {
    constructor() {
      super();
      this.header = this.querySelector('header');
      this.hamburgerToggle = this.querySelector('.hamburger-toggle');
      this.mobileMenu = this.querySelector('#mobile-menu');
      this.mobileMenuBackdrop = this.querySelector('#mobile-menu-backdrop');
      this.hamburgerIcon = this.querySelector('.hamburger-icon');
      this.closeIcon = this.querySelector('.close-icon');
      this.logoDefault = this.querySelector('.logo-default');
      this.logoInverted = this.querySelector('.logo-inverted');
      this.nav = this.querySelector('nav');
      this.resizeObserver = null;
      this.isMenuOpen = false;
    }

    connectedCallback() {
      this.setHeaderHeight();

      this.resizeObserver = new ResizeObserver(() => {
        this.setHeaderHeight();
      });

      if (this.header) {
        this.resizeObserver.observe(this.header);
      }

      if (this.hamburgerToggle) {
        this.hamburgerToggle.addEventListener('click', () => this.#toggleMenu());
      }

      if (this.mobileMenuBackdrop) {
        this.mobileMenuBackdrop.addEventListener('click', () => this.#closeMenu());
      }

      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && this.isMenuOpen) {
          this.#closeMenu();
        }
      });

      const menuLinks = this.mobileMenu?.querySelectorAll('a');
      if (menuLinks) {
        for (const link of menuLinks) {
          link.addEventListener('click', () => this.#closeMenu());
        }
      }
    }

    disconnectedCallback() {
      if (this.resizeObserver) {
        this.resizeObserver.disconnect();
      }
    }

    setHeaderHeight() {
      if (!this.header) return;

      const height = this.header.offsetHeight;
      document.documentElement.style.setProperty('--header-height', `${height}px`);
    }

    #toggleMenu() {
      this.isMenuOpen = !this.isMenuOpen;

      if (this.isMenuOpen) {
        this.#openMenu();
      } else {
        this.#closeMenu();
      }
    }

    #openMenu() {
      this.isMenuOpen = true;

      if (this.mobileMenuBackdrop) {
        this.mobileMenuBackdrop.classList.remove('opacity-0', 'pointer-events-none');
        this.mobileMenuBackdrop.classList.add('opacity-100');
        this.mobileMenuBackdrop.setAttribute('aria-hidden', 'false');
      }

      if (this.mobileMenu) {
        this.mobileMenu.classList.remove('opacity-0', 'pointer-events-none');
        this.mobileMenu.classList.add('opacity-100');
        this.mobileMenu.setAttribute('aria-hidden', 'false');
      }

      if (this.nav) {
        this.nav.style.backgroundColor = 'rgba(255, 255, 255, 0.95)';
        this.nav.classList.add('text-black', 'rounded-t-2xl');
        this.nav.classList.remove('text-white', 'rounded-2xl');
      }

      if (this.hamburgerToggle) {
        this.hamburgerToggle.setAttribute('aria-expanded', 'true');
        this.hamburgerToggle.classList.add('text-black');
      }

      if (this.hamburgerIcon && this.closeIcon) {
        this.hamburgerIcon.classList.add('hidden');
        this.closeIcon.classList.remove('hidden');
      }

      if (this.logoDefault && this.logoInverted) {
        this.logoDefault.classList.add('hidden');
        this.logoInverted.classList.remove('hidden');
      }

      const mailIcon = this.querySelector('a[aria-label="Contact us"]');
      if (mailIcon) {
        mailIcon.classList.add('text-black');
      }
    }

    #closeMenu() {
      this.isMenuOpen = false;

      if (this.mobileMenuBackdrop) {
        this.mobileMenuBackdrop.classList.add('opacity-0', 'pointer-events-none');
        this.mobileMenuBackdrop.classList.remove('opacity-100');
        this.mobileMenuBackdrop.setAttribute('aria-hidden', 'true');
      }

      if (this.mobileMenu) {
        this.mobileMenu.classList.add('opacity-0', 'pointer-events-none');
        this.mobileMenu.classList.remove('opacity-100');
        this.mobileMenu.setAttribute('aria-hidden', 'true');
      }

      if (this.nav) {
        this.nav.style.backgroundColor = 'rgba(115, 115, 115, 0.2)';
        this.nav.classList.remove('text-black', 'rounded-t-2xl');
        this.nav.classList.add('text-white', 'rounded-2xl');
      }

      if (this.hamburgerToggle) {
        this.hamburgerToggle.setAttribute('aria-expanded', 'false');
        this.hamburgerToggle.classList.remove('text-black');
      }

      if (this.hamburgerIcon && this.closeIcon) {
        this.hamburgerIcon.classList.remove('hidden');
        this.closeIcon.classList.add('hidden');
      }

      if (this.logoDefault && this.logoInverted) {
        this.logoDefault.classList.remove('hidden');
        this.logoInverted.classList.add('hidden');
      }

      const mailIcon = this.querySelector('a[aria-label="Contact us"]');
      if (mailIcon) {
        mailIcon.classList.remove('text-black');
      }
    }
  }

  if (!customElements.get('site-header')) {
    customElements.define('site-header', SiteHeader);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["logo-text-marquee"] && !Shopify.designMode) return;
  try {
    
  class LogoTextMarquee extends HTMLElement {
    constructor() {
      super();
      this.initialized = false;
    }

    connectedCallback() {
      // Wait for images with a timeout fallback
      Promise.race([this.waitForImages(), new Promise((resolve) => setTimeout(resolve, 3000))]).then(() => {
        requestAnimationFrame(() => this.init());
      });
    }

    waitForImages() {
      const images = this.querySelectorAll('.logo-text-marquee__image, .logo-text-marquee__icon img');
      if (images.length === 0) return Promise.resolve();

      return Promise.all(
        Array.from(images).map((img) =>
          img.complete
            ? Promise.resolve()
            : new Promise((resolve) => {
                img.addEventListener('load', resolve, { once: true });
                img.addEventListener('error', resolve, { once: true });
              }),
        ),
      );
    }

    init() {
      if (this.initialized) return;

      const track = this.querySelector('.logo-text-marquee__track');
      if (!track) return;

      const container = track.parentElement;
      if (!container) return;

      const items = track.querySelectorAll('.logo-text-marquee__item');
      if (items.length === 0) return;

      // Measure from start of first item to start of duplicate (seamless loop)
      const firstSetCount = items.length / 4;
      const firstItem = items[0];
      const duplicateItem = items[firstSetCount]; // First item of second set

      // Distance from first item start to duplicate item start (includes all gaps)
      const firstSetWidth = duplicateItem.offsetLeft - firstItem.offsetLeft;

      // Ensure we have valid measurements
      if (!firstSetWidth || firstSetWidth <= 0) {
        console.warn('LogoTextMarquee: Invalid measurements, retrying...');
        setTimeout(() => this.init(), 100);
        return;
      }

      // Calculate duration: speed is pixels per second
      const speed = parseFloat(this.dataset.speed) || 30;
      const duration = (firstSetWidth / speed) * 1000;
      const direction = this.dataset.direction || 'left';

      // Set CSS variables for smooth animation
      track.style.setProperty('--animation-duration', `${duration}ms`);
      track.style.setProperty('--translate-x', `${firstSetWidth}px`);

      // Add direction class for different animations
      if (direction === 'right') {
        track.classList.add('is-direction-right');
        // Set initial position to prevent flash - start from left
        track.style.transform = `translateX(-${firstSetWidth}px)`;
      } else {
        track.classList.remove('is-direction-right');
        track.style.transform = '';
      }

      this.initialized = true;
    }
  }

  if (!customElements.get('logo-text-marquee')) {
    customElements.define('logo-text-marquee', LogoTextMarquee);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["scrolling-text"] && !Shopify.designMode) return;
  try {
    
  class ScrollingText extends HTMLElement {
    constructor() {
      super();
      this.initialized = false;
      this.scrollDistance = 100; // pixels to scroll per segment after sticking
    }

    connectedCallback() {
      // Wait for content to render
      setTimeout(() => {
        requestAnimationFrame(() => {
          this.init();
        });
      }, 100);
    }

    disconnectedCallback() {
      if (this.scrollHandler) {
        window.removeEventListener('scroll', this.scrollHandler);
      }
    }

    init() {
      this.segments = Array.from(this.querySelectorAll('.scrolling-text__segment'));
      this.content = this.querySelector('.scrolling-text__content');
      this.blockCount = parseInt(this.dataset.blockCount, 10) || 0;

      if (this.segments.length === 0 || this.initialized || !this.content) return;

      this.initialized = true;

      // Calculate and set section height
      // First segment is active before sticking, remaining segments share the scroll space
      const remainingSegments = Math.max(0, this.blockCount - 1);
      const additionalHeight = remainingSegments * this.scrollDistance;

      const isMobile = matchMedia('(max-width: 767px)').matches;

      // Force a reflow to get accurate height
      const contentHeight = this.content.offsetHeight;
      // Minimal extra padding to keep it around 800px total
      const totalHeight = isMobile ? contentHeight + additionalHeight : contentHeight + additionalHeight + 300;

      this.style.minHeight = `${totalHeight}px`;

      // Set initial colors
      this.segments.forEach((segment, index) => {
        if (index === 0) {
          segment.style.color = 'rgb(255, 255, 255)';
        } else {
          segment.style.color = 'rgba(255, 255, 255, 0.6)';
        }
      });

      // Create bound handler
      this.scrollHandler = this.handleScroll.bind(this);
      window.addEventListener('scroll', this.scrollHandler, { passive: true });

      // Initial check
      this.handleScroll();
    }

    handleScroll() {
      if (!this.segments.length || !this.content) return;

      const rect = this.getBoundingClientRect();
      const contentRect = this.content.getBoundingClientRect();

      // Get the actual header height from CSS variable
      const headerHeight = parseInt(
        getComputedStyle(document.documentElement).getPropertyValue('--header-height') || '100',
      );

      // Check if sticky element has reached its stuck position
      const isStuck = contentRect.top <= headerHeight + 1;

      if (!isStuck) {
        // Not stuck yet, keep initial state (only first segment white)
        this.segments.forEach((segment, index) => {
          segment.style.color = index === 0 ? 'rgb(255, 255, 255)' : 'rgba(255, 255, 255, 0.6)';
        });
        return;
      }

      // First segment is active before sticking
      // Once stuck, immediately move to segment 2 (index 1)
      // Then divide remaining scroll distance among remaining segments
      const scrollProgress = Math.max(0, -rect.top - headerHeight);

      // Calculate which segment should be active
      // Segments after the first (index 1+) each get scrollDistance of scroll time
      let activeIndex = 1; // Start from second segment since first was active before sticking

      if (this.blockCount > 1) {
        // Determine active segment based on scroll progress
        const segmentIndex = Math.floor(scrollProgress / this.scrollDistance) + 1;
        activeIndex = Math.min(segmentIndex, this.blockCount - 1);
      }

      this.segments.forEach((segment, index) => {
        if (index < activeIndex) {
          // Already completed - gray
          segment.style.color = 'rgba(255, 255, 255, 0.6)';
        } else if (index === activeIndex) {
          // Currently active segment - white
          segment.style.color = 'rgb(255, 255, 255)';
        } else {
          // Future segments - gray
          segment.style.color = 'rgba(255, 255, 255, 0.6)';
        }
      });
    }
  }

  if (!customElements.get('scrolling-text')) {
    customElements.define('scrolling-text', ScrollingText);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["statistics-banner"] && !Shopify.designMode) return;
  try {
    
  const initScrollAnimations = () => {
    const containers = document.querySelectorAll('[data-animation]');
    containers.forEach((container) => {
      const stagger = container.dataset.animationStagger === 'true';
      const once = container.dataset.animationOnce === 'true';

      if (stagger) {
        const blocks = container.querySelectorAll(':scope > *');
        blocks.forEach((block, i) => block.style.setProperty('--stagger-index', i));
      }

      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              container.classList.add('scroll-animate--visible');
              if (once) observer.unobserve(entry.target);
            } else if (!once) {
              container.classList.remove('scroll-animate--visible');
            }
          });
        },
        { threshold: 0.5 },
      );

      observer.observe(container);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initScrollAnimations);
  } else {
    initScrollAnimations();
  }

  } catch(e) { console.error(e); }
})();
})();
